/**
 * Theme Manager - Quản lý việc chuyển đổi theme theo site
 */

class ThemeManager {
    constructor() {
        this.currentTheme = 'default';
        this.themes = ['default', 'admin', 'staff', 'user'];
    }

    /**
     * Khởi tạo theme dựa trên URL hoặc localStorage
     */
    init() {
        const savedTheme = localStorage.getItem('pac-k-theme');
        const urlTheme = this.detectThemeFromURL();

        const themeToApply = urlTheme || savedTheme || 'default';
        this.applyTheme(themeToApply);
    }

    /**
     * Phát hiện theme từ URL hiện tại
     */
    detectThemeFromURL() {
        const pathname = window.location.pathname;

        if (pathname.includes('/admin/') || pathname.includes('a_frame.php')) {
            return 'admin';
        } else if (pathname.includes('/staff/') || pathname.includes('s_frame.php')) {
            return 'staff';
        } else if (pathname.includes('/user/') || pathname.includes('u_frame.php')) {
            return 'user';
        }

        return null;
    }

    /**
     * Áp dụng theme mới
     */
    applyTheme(themeName) {
        if (!this.themes.includes(themeName)) {
            themeName = 'default';
        }

        // Áp dụng theme mới thông qua data-theme (đồng bộ với CSS)
        this.currentTheme = themeName;
        document.documentElement.setAttribute('data-theme', themeName);

        // Lưu vào localStorage
        localStorage.setItem('pac-k-theme', themeName);

        // Dispatch event để các component khác có thể lắng nghe
        window.dispatchEvent(
            new CustomEvent('themeChanged', {
                detail: { theme: themeName }
            })
        );
    }

    /**
     * Chuyển đổi giữa các theme có sẵn
     */
    cycleTheme() {
        const currentIndex = this.themes.indexOf(this.currentTheme);
        const nextIndex = (currentIndex + 1) % this.themes.length;
        const nextTheme = this.themes[nextIndex];

        this.applyTheme(nextTheme);
    }

    /**
     * Lấy theme hiện tại
     */
    getCurrentTheme() {
        return this.currentTheme;
    }

    /**
     * Lấy danh sách theme có sẵn
     */
    getAvailableThemes() {
        return [...this.themes];
    }

    /**
     * Reset về theme mặc định
     */
    resetToDefault() {
        this.applyTheme('default');
    }
}

// Tạo instance global
const themeManager = new ThemeManager();

// Export để sử dụng trong module
export default themeManager;

// Export cho global scope (nếu cần)
if (typeof window !== 'undefined') {
    window.themeManager = themeManager;
}
